import { Component, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { GoogleSheetsDbService } from 'ng-google-sheets-db';
import {
    WhiskeyItem,
    SpecialsItem,
    BarrelItem,
    Flight,
    SheetNames,
    barrelItemAttributesMapping,
    whiskeyAttributesMapping,
    specialsAttributeMapping,
    flightAttributesMapping
} from './menu.model'

@Component({
  selector: 'root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
    constructor(private googleSheetsDbService: GoogleSheetsDbService, private readonly cd: ChangeDetectorRef) {
        this.getData();
    }

    @ViewChild("myTop") myTop: ElementRef | undefined;

    flightList: Array<Flight> = [];
    reserveList: Array<WhiskeyItem> = [];
    bourbonList: Array<WhiskeyItem> = [];
    irishList: Array<WhiskeyItem> = [];
    scotchList: Array<WhiskeyItem> = [];
    japaneseList: Array<WhiskeyItem> = [];
    ryeList: Array<WhiskeyItem> = [];
    americanList: Array<WhiskeyItem> = [];
    otherList: Array<WhiskeyItem> = [];
    specials: Array<SpecialsItem> = [];
    bottleList: Array<BarrelItem> = [];
    drinkForCause: Array<SpecialsItem> = [];
    verticalFlights: Array<Flight> = [];

    activeSection: string = 'Flight Boards';
    fontSize: string = 'small';
    contrast: string = 'dark';
    
    sheetID: string = '1XpMJ-edGNMa8Y6GaC_qlDG12xGnQzWvbp04xhEvw5Ac';

    onNavChange(value: string) {
        this.activeSection = value;
        console.log(this.activeSection);

        // @ts-ignore
        this.myTop.nativeElement.scrollTo(0,0);
    }

    onFontChange(value: string) {
        this.fontSize = value;
    }

    onContrastChange(value: string) {
        this.contrast = value;
    }

    getData() {
        this.googleSheetsDbService
        .get<WhiskeyItem>(this.sheetID, SheetNames.FLIGHTS, whiskeyAttributesMapping)
        .subscribe((list: any) => {
            this.flightList = list
        });

        this.googleSheetsDbService
        .get<WhiskeyItem>(this.sheetID, SheetNames.RESERVE, whiskeyAttributesMapping)
        .subscribe((list: any) => {
            this.reserveList = list;
        });

        this.googleSheetsDbService
        .get<WhiskeyItem>(
            this.sheetID,
            SheetNames.BOURBON,
            whiskeyAttributesMapping
        ).subscribe((list: any) => {
            this.bourbonList = list;
            this.cd.markForCheck();
        });

        this.googleSheetsDbService
        .get<WhiskeyItem>(
            this.sheetID,
            SheetNames.IRISH,
            whiskeyAttributesMapping
        ).subscribe((list: any) => {
            this.irishList = list;
        });

        this.googleSheetsDbService
        .get<WhiskeyItem>(
            this.sheetID,
            SheetNames.SCOTCH,
            whiskeyAttributesMapping
        ).subscribe((list: any) => {
            this.scotchList = list;
        });

        this.googleSheetsDbService
        .get<WhiskeyItem>(
            this.sheetID,
            SheetNames.JAPANESE,
            whiskeyAttributesMapping
        ).subscribe((list: any) => {
            this.japaneseList = list;
        });

        this.googleSheetsDbService
        .get<WhiskeyItem>(
            this.sheetID,
            SheetNames.RYE,
            whiskeyAttributesMapping
        ).subscribe((list: any) => {
            this.ryeList = list;
        });

        this.googleSheetsDbService
        .get<WhiskeyItem>(
            this.sheetID,
            SheetNames.AMERICAN,
            whiskeyAttributesMapping
        ).subscribe((list: any) => {
            this.americanList = list;
        });

        this.googleSheetsDbService
        .get<WhiskeyItem>(
            this.sheetID,
            SheetNames.OTHER,
            whiskeyAttributesMapping
        ).subscribe((list: any) => {
            this.otherList = list;
        });

        this.googleSheetsDbService
        .get(
            this.sheetID,
            SheetNames.SPECIALS,
            specialsAttributeMapping
        ).subscribe((list: any) => {
            this.specials = list;
        });

        this.googleSheetsDbService
        .get<any>(
            this.sheetID,
            SheetNames.DRINKS_FOR_A_CAUSE,
            specialsAttributeMapping
        ).subscribe((list: any) => {
            this.drinkForCause = list;
        });

        this.googleSheetsDbService
        .get<BarrelItem>(
            this.sheetID,
            SheetNames.BARREL_PICKS,
            barrelItemAttributesMapping
        ).subscribe((list: any) => {
            this.bottleList = list;
        });

        this.googleSheetsDbService
            .get<Flight>(
                this.sheetID,
                SheetNames.VERTICAL_FLIGHTS,
                flightAttributesMapping
            ).subscribe((list: any) => {
            this.verticalFlights = list;
        });
    }
}
